import React from 'react';
import MenuItem from '@material-ui/core/MenuItem';

export type MenuItemAnchorProps = React.HTMLProps<HTMLAnchorElement>;

export default React.forwardRef(
    // eslint-disable-next-line prefer-arrow-callback
    function MenuItemAnchor(props: MenuItemAnchorProps, ref: React.Ref<any>) {
        // @ts-ignore The MUI type definitions do not support the "component" prop
        return <MenuItem ref={ref} {...props} component='a' />;
    }
);
